<template>
    <div class="mt-15">
        <div id="section-container" @click="makeCardEditable('question'+ sectionIndex, index)"
             class="quiz-card col-12 shadow-sm">
            <div v-show="currentlyEditingCardType === 'question' + sectionIndex && currentlyEditingCardIndex === index"
                 class="editing-indicator"></div> <!-- Editing indicator -->
            <div class="flex-column" style="padding: 24px">
                <span class="d-inline-block ml-15 mb-10 px-10 py-5 font-weight-bold"
                      style="border: .15em solid black; border-radius: 30%">
                    Q {{ index + 1 }}
                </span>
                <div class="row">
                    <div @click="makeEditable('question' + compositeId, index)" class="col-md-9 col-sm-12 pb-10">
                        <div
                            v-if="currentlyEditingItemType === 'question' + compositeId && currentlyEditingItemIndex === index">
                            <SummerNote
                                :index=compositeId
                                :on-change="onChange"
                                :on-change-content="onChangeContent"
                                for-type="question"
                                :error="error.body"
                                :content=question.body>
                            </SummerNote>
                        </div>
                        <div v-else>
                            <div class="show-question">
                                <p v-html="question.body.trim() === '' ? 'Question' : question.body.trim()" class="p-5"></p>
                            </div>
                            <small class="invalid-feedback d-block"
                                   v-show="error.body">
                                {{ error.body }}
                            </small>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <FormElementWithoutLabel
                            :error="error.answer_type"
                        >
                            <select
                                class="form-control"
                                title="Type"
                                :id="`question_type_${compositeId}`"
                                v-model="question.answer_type"
                                @change="onChangeAnsType($event)"
                            >
                                <option value="mcq"> MCQ</option>
                                <option value="short_ans"> Short answer</option>
                            </select>
                        </FormElementWithoutLabel>
                    </div>
                </div>
              <div class="mt-20 mb--20">
                <FormElementWithoutLabel v-if="question.answer_type === 'short_ans'">
                  <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success ml-15">
                    <input
                        :id="`is_answer_case_sensitive${index}`"
                        type="checkbox"
                        v-model="question.is_answer_case_sensitive"
                    >
                    <label :for="`is_answer_case_sensitive${index}`" class="pl-20 pt-10">
                      Answer is Case Sensitive
                    </label>
                  </div>
                </FormElementWithoutLabel>
              </div>
                <FormElement
                    v-show="question.answer_type === 'short_ans'"
                    label-class="ml-30 mb--30"
                    label="Correct Answers:">
                </FormElement>

                <div style="overflow-x: auto">
                    <VueDraggable ref="op" v-model="question.options" tag="div">
                        <div v-for="(option, option_index) in question.options" :key="option_index"
                             class="option-grabber">
                            <QuestionOption
                                v-show="question.answer_type === 'mcq'"
                                :index="option_index"
                                :question-index="index"
                                :section-index="sectionIndex"
                                :currently-editing-item-type="currentlyEditingItemType"
                                :currently-editing-item-index="currentlyEditingItemIndex"
                                :option="option.option"
                                :has-edit-permission="hasEditPermission"
                                :unable-to-add-or-delete-msg="unableToAddOrDeleteMsg"
                                :error="option.error"
                                :make-editable="makeEditable"
                                :remove-option="removeOption"
                                :add-more-action="addOption"
                            >
                            </QuestionOption>

                            <ShortAnswer
                                v-show="question.answer_type === 'short_ans'"
                                :ref="`short_answer_component_${option_index}`"
                                :index="option_index"
                                :question-index=index
                                :section-index=sectionIndex
                                :option="option.option"
                                :has-edit-permission="hasEditPermission"
                                :unable-to-add-or-delete-msg="unableToAddOrDeleteMsg"
                                :error="option.error"
                                :remove-option="removeOption"
                                :add-more-action="addShortAnswer"
                                :should-focus="option.shouldFocus"
                            >

                            </ShortAnswer>
                        </div>
                    </VueDraggable>

                </div>

                <button class="btn btn-transparent mb-2"
                        style="background-color: inherit"
                        @click="question.answer_type === 'short_ans' ? addShortAnswer() : (hasEditPermission ? addOption() : unableToAddOrDeleteMsg())">
                    <span class="text-primary">Add more</span>
                </button>

                <div class="question-card-footer">
                    <div class="question-card-footer-left mt-10">
                        <div class="d-flex align-items-center">
                            <div>
                                Points:
                                <span class="text-success">
                                    <span class="hidden-lg-up"><i class="fa-solid fa-check"></i></span>
                                    <span class="hidden-md-down">Correct</span>
                                    : {{ question.correct_points }}
                                </span>
                                |
                                <span class="text-danger">
                                    <span class="hidden-lg-up"><i class="fa-solid fa-xmark"></i></span>
                                    <span class="hidden-md-down">Incorrect</span>
                                    : {{ question.incorrect_points }}
                                </span>
                                |
                                <span>
                                    <span class="hidden-lg-up">U</span>
                                    <span class="hidden-md-down">Unanswered</span>
                                    : {{ question.unanswered_points }}
                                </span>
                            </div>
                            <button class="btn bg-transparent point-btn ml-20" @click="togglePointsForm()">
                                <i class="fa-solid fa-edit"></i>
                            </button>
                        </div>
                    </div>

                    <div class="question-card-footer-right">
                        <div class="d-none d-lg-block">
                            <button class="btn btn-md bg-transparent" title="Duplicate Question Below"
                                    @click="hasEditPermission ? duplicateQuestion(index) : unableToAddOrDeleteMsg()"><i
                                class="fa-solid fa-copy"></i></button>
                            <button class="btn btn-md bg-transparent" title="Add Question Below"
                                    @click="hasEditPermission ? addQuestion(index+1) : unableToAddOrDeleteMsg()"><i
                                class="fa-solid fa-plus-circle"></i></button>
                            <button class="btn btn-md bg-transparent" title="Delete Question"
                                    @click="hasEditPermission ? confirmQuestionRemoval() : unableToAddOrDeleteMsg()"><i
                                class="fa-solid fa-trash-can"></i></button>
                            <button class="btn btn-md bg-transparent drag-handler"><i
                                class="fa-solid fa-arrows-from-line"></i></button>
                        </div>

                        <div class="dropdown d-lg-none">
                            <button class="btn btn-primary btn-round w-40 h-40" type="button"
                                    id="page-action-button-mobile"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-ellipsis-vertical"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="page-action-button-mobile">
                                <button type="button" class="dropdown-item"
                                        @click="hasEditPermission ? addQuestion(index+1) : unableToAddOrDeleteMsg()">
                                    <i class="fa-solid fa-plus-circle w-20 mr-5 text-center"></i><span>Add Question Below</span>
                                </button>
                                <button type="button" class="dropdown-item"
                                        @click="hasEditPermission ? confirmQuestionRemoval() : unableToAddOrDeleteMsg()">
                                    <i class="fa-solid fa-trash-can w-20 mr-5 text-center"></i><span>Delete Question</span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="ml-4" v-show="pointFormToggle || showPointFormIfAnyError">
                    <FormElement
                        :error="error.correct_points"
                        label="Points if correct"
                        :label-for-id="`correct_point_${compositeId}`"
                        label-class="required"
                    >
                        <input :id="`correct_point_${compositeId}`"
                               type="number"
                               v-model="question.correct_points"
                               class="form-control"/>
                    </FormElement>

                    <FormElement
                        :error="error.incorrect_points"
                        label="Points if incorrect"
                        :label-for-id="`pass_marks_${compositeId}`"
                        label-class="required"
                    >
                        <input :id="`incorrect_marks_${compositeId}`"
                               type="number"
                               v-model="question.incorrect_points"
                               class="form-control"/>
                    </FormElement>

                    <FormElement
                        :error="error.unanswered_points"
                        label="Points if unanswered"
                        :label-for-id="`unanswered_marks_${compositeId}`"
                        label-class="required"
                    >
                        <input :id="`unanswered_marks_${compositeId}`"
                               type="number"
                               v-model="question.unanswered_points"
                               class="form-control"/>
                    </FormElement>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        },
        error: {
            type: Object,
            required: false,
        },
        currentlyEditingItemType: {
            type: String,
            required: true,
        },
        currentlyEditingItemIndex: {
            type: Number,
            required: true
        },
        currentlyEditingCardType: {
            type: String,
            required: true,
        },
        currentlyEditingCardIndex: {
            type: Number,
            required: true
        },
        index: {
            type: Number,
            required: true,
        },
        sectionIndex: {
            type: Number,
            required: true,
        },
        addQuestion: {
            type: Function,
            required: true,
        },
        duplicateQuestion: {
            type: Function,
            required: true,
        },
        removeQuestion: {
            type: Function,
            required: true,
        },
        makeEditable: {
            type: Function,
            required: true
        },
        makeCardEditable: {
            type: Function,
            required: true
        },
        hasEditPermission: {
            type: Boolean,
            required: true,
        },
        unableToAddOrDeleteMsg: {
            type: Function,
            required: true
        }
    },
    computed: {
        compositeId: function () {
            return `${this.sectionIndex}_${this.index}`;
        },

        showPointFormIfAnyError: function () {
            return this.error.incorrect_points || this.error.correct_points || this.error.unanswered_points
        }
    },
    methods: {
        onChange(text) {
            this.question.title = text
        },
        onChangeContent(content) {
            this.question.body = content
        },
        addOption() {
            this.question.options.push({
                option: {
                    title: '',
                    body: '',
                    is_correct: false
                },
                error: {
                    title: '',
                    body: '',
                    is_correct: ''
                }
            });
            this.makeEditable('option', this.question.options.length - 1);
        },
        onChangeAnsType(event) {
            if (event.target.value === 'short_ans') {
                const regX = /(<([^>]+)>)/ig;
                let correctAns = this.question.options.filter(item => item.option.is_correct);
                let newOptions = [];
                for (let index in correctAns) {
                    correctAns[index].option.body = correctAns[index].option.body.replace(regX, "").replace(/&nbsp;/g, " ").trim();
                    newOptions.push(
                        {
                            option: correctAns[index].option,
                            error: {
                                title: '',
                                body: '',
                                is_correct: ''
                            }
                        }
                    )
                }
                this.question.options = newOptions;
            }
        },
        addShortAnswer() {
            for (let i = 0; i < this.question.options.length; i++) {
                this.question.options[i].shouldFocus = false
            }

            this.question.options.push({
                option: {
                    title: '',
                    body: '',
                    is_correct: true
                },
                error: {
                    title: '',
                    body: '',
                    is_correct: ''
                },
                shouldFocus: true,
            });
        },
        removeOption(index) {
            if (this.question.options.length > 1) {
                this.question.options.splice(index, 1);
            }
        },
        confirmQuestionRemoval() {
            Swal.fire(
                {
                    title: "Delete Question?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#f2353c",
                    confirmButtonText: "Yes, delete!",
                }
            ).then(result => {
                if (result.isConfirmed) {
                    this.removeQuestion(this.index);
                }
            });
        },
    }
}
</script>
<script setup>
import FormElement from "../../../components/FormElement.vue";
import SummerNote from "../../../components/SummerNote.vue";
import ShortAnswer from "./ShortAnswer.vue";
import "./Question.vue";
import QuestionOption from "./QuestionOption.vue";
import FormElementWithoutLabel from "../../../components/FormElementWithoutLabel.vue";
import {ref} from "vue";
import {VueDraggable} from 'vue-draggable-plus'

const pointFormToggle = ref(false);

function togglePointsForm() {
    pointFormToggle.value = !pointFormToggle.value;
}

</script>
<style scoped>
.header {
    border-bottom: 1px solid black;
}

.header-question {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.header-btn {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    max-height: 55px;
}

.question-card-footer {
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    border-top: 1px solid #dadce0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    position: relative;
}

.question-card-footer-left {
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}

.question-card-footer-right {
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    position: absolute;
    top: 10px;
    right: 10px;
}

.point-btn {
    border: none;
    background-color: inherit;
    cursor: pointer;
    display: inline-block;
}

.point-btn:focus {
    border: none;
    outline: none;
}

.show-question {
    display: flex;
    padding: 10px 10px 0;
    align-items: center;
    width: 100%;
    height: 100%;
}

.option-grabber div:hover {
    cursor: move;
}

</style>
